import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { refresh_model_modal } from '../../input_output';
import refresh_svg from '../../../assets/img/SVG_icons/Left/main_control/refresh.svg';
import { img } from '@phi/components';
import RefreshTooltip from './RefreshTooltip';

export const RefreshIcon = refresh_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        disabled() {
            return !this.state.loaded;
        },

        alt() {
            return 'Refresh the application';
        },

        coming_soon() {
            return !this.state.loaded;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                refresh_model_modal();
        },
    },

    render() {
        return h(BarButton, {
            disabled: this.disabled,
            id: 'refresh-button',
            onClick: this.onClick,
            tippy: 'right',
            selected: this.state.tut_stage === 1,
            help: 'refresh',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(refresh_svg, this.alt),
            tooltip: RefreshTooltip,
        });
    },
});
